import PackDashboard from "./PackDashboard";

export default {
    list: PackDashboard,
}
